<section *ngIf="statusLoading === loadingState.isLoading" class="loading full-page">
  <div class="mat-progress-spinner custom-mat-progress-spinner spinner-loading-01">
    <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve">
      <path opacity="0.2" fill="#000" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634 c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z" />
      <path fill="#000" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z"><animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 20 20" to="360 20 20" dur="0.5s" repeatCount="indefinite"/></path>
    </svg>
  </div>
</section>

<section *ngIf="statusLoading === loadingState.isLoaded" class="wrapper">
  <div *ngIf="user.firstName" class="header">
    <div class="logo">
      <div class="ico-isologo"></div>
      <div class="ico-logotype"></div>
    </div>
    <div class="welcome">
      <reb-ngx-heading-label class="welcome-title" size="h1" weight="400" color="#454F59" >Welcome back, {{ user.firstName }}!</reb-ngx-heading-label>
      <reb-ngx-label size="16" weight="400" color="#454F59" *ngIf="!hasPendingActivation" >Select a company or <a class='custom-mat-link active' [routerLink]="['/setup']">create a new one</a></reb-ngx-label>
      <reb-ngx-label size="16" weight="400" color="#454F59" *ngIf="hasPendingActivation && collectionOfUserCompany.length > 0" >Select a company</reb-ngx-label>

    </div>
  </div>
  <div class="body">
    <div *ngIf="collectionOfUserCompany && collectionOfUserCompany.length > 0" class="section">
      <app-user-company
        class="size size1of1"
        [hasMessage] = "activeCompanies.code !== 200"
        [collectionOfUserCompany] = collectionOfUserCompany
      ></app-user-company>
    </div>
    <div *ngIf="hasPendingActivation && pendingActivation.data.length > 0" class="section">
      <app-pending-activation
          class="size size1of1"
          [hasMessage] = "pendingActivation.code !== 200"
          [collectionOfPendingCompanies] = collectionOfPendingCompanies
      ></app-pending-activation>
    </div>
  </div>
  <div class="footer">
    <reb-ngx-label size="12" weight="400" color="#454F59">© All Rights Reserved. Rebillia Platform® is a registered trademark of Rebillia LLC. <a class='custom-mat-link active' href="https://rebillia.com/privacy_policy/">Privacy</a> and <a class='custom-mat-link active' href="https://rebillia.com/terms_of_use/">Terms</a>.</reb-ngx-label>
  </div>
</section>
